import { render, staticRenderFns } from "./personPerfect.vue?vue&type=template&id=73ddb57b&scoped=true"
import script from "./personPerfect.vue?vue&type=script&lang=js"
export * from "./personPerfect.vue?vue&type=script&lang=js"
import style0 from "./personPerfect.vue?vue&type=style&index=0&id=73ddb57b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ddb57b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ddb57b')) {
      api.createRecord('73ddb57b', component.options)
    } else {
      api.reload('73ddb57b', component.options)
    }
    module.hot.accept("./personPerfect.vue?vue&type=template&id=73ddb57b&scoped=true", function () {
      api.rerender('73ddb57b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentPic/personPerfect/personPerfect.vue"
export default component.exports